import { AxiosResponse } from 'axios';

import authNetworkService from '../auth-network/auth-network.service';
import operationsUrls from './operations.urls';

const createProgressHandler =
  (onUploadProgress: (percentage: number) => void) => (progressEvent: ProgressEvent) => {
    if (!progressEvent.lengthComputable || !progressEvent.total) {
      return;
    }
    onUploadProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total));
  };

const uploadCapeTownImportFile = (
  file: File,
  email: string,
  onUploadProgress?: (percentage: number) => void,
) => {
  const url = operationsUrls.uploadCapeTownImportFile();
  const form = new FormData();
  form.append('File', file);
  form.append('NotifyEmail', email);
  return authNetworkService.post(url, form, {
    timeout: 0,
    onUploadProgress: onUploadProgress && createProgressHandler(onUploadProgress),
  });
};

const uploadTmtFinesImportFile = (
  file: File,
  email: string,
  onUploadProgress?: (percentage: number) => void,
) => {
  const url = operationsUrls.uploadTmtFinesImportFile();
  const form = new FormData();
  form.append('File', file);
  form.append('NotifyEmail', email);
  return authNetworkService.post(url, form, {
    timeout: 0,
    onUploadProgress: onUploadProgress && createProgressHandler(onUploadProgress),
  });
};

const uploadBulkImportFile = (
  file: File,
  email: string,
  onUploadProgress?: (percentage: number) => void,
) => {
  const url = operationsUrls.uploadBulkImportFile();
  const form = new FormData();
  form.append('File', file);
  form.append('NotifyEmail', email);
  return authNetworkService.post(url, form, {
    timeout: 0,
    onUploadProgress: onUploadProgress && createProgressHandler(onUploadProgress),
  });
};

const uploadPayFastImportFile = (file: File, email: string) => {
  const url = operationsUrls.uploadPayFastImportFile();
  const form = new FormData();
  form.append('File', file);
  form.append('NotifyEmail', email);
  return authNetworkService.post(url, form, {
    timeout: 0,
  });
};

const uploadInvalidEmailImportFile = (file: File, email: string) => {
  const url = operationsUrls.uploadInvalidEmailImportFile();
  const form = new FormData();
  form.append('file', file);
  form.append('NotifyEmail', email);
  return authNetworkService.post(url, form, {
    timeout: 0,
  });
};

const exportCapeTownWeeklyOffenderIdentifiers = (): Promise<AxiosResponse<Blob>> => {
  const url = operationsUrls.exportWeeklyTmtCapeTown();
  return authNetworkService.get(url, {
    responseType: 'blob',
    timeout: 0,
  });
};

export default {
  uploadBulkImportFile,
  uploadPayFastImportFile,
  uploadCapeTownImportFile,
  uploadTmtFinesImportFile,
  uploadInvalidEmailImportFile,
  exportCapeTownWeeklyOffenderIdentifiers,
};
